import 'css-chunksrc/client/scenes/wbs/task/taskStatus/styles.scss';export default {
  "taskStatus": "_taskStatus_1qktz_1",
  "name": "_name_1qktz_7"
};